import React, { useState, useMemo } from 'react';
import { Tiles } from 'wsm-tiles';
import { usePrefs } from 'ws-scripts/modules/common';
import { useGroupLogos } from '../hooks/useGroupLogos';
import { PaginationProvider } from '../contexts/PaginationContext';
import { TILE_SIZE_MAP } from '../global-constants';
import { getItemsPerPage, paginateData } from '../utils/pagination';
import Pagination from './pagination/Pagination';
import '../global-sass/main.scss';

const MiniGridView = () => {
	const { exposedLabel, tileSize } = usePrefs();
	const showLabel = exposedLabel === 'true';
	const groupLogos = useGroupLogos(showLabel);
	const [offset, setOffset] = useState(0);
	const itemsPerPage = getItemsPerPage(tileSize);

	// Synchronous slice - no useEffect delay
	const visibleLogos = useMemo(
		() => paginateData(groupLogos || [], offset, itemsPerPage),
		[groupLogos, offset, itemsPerPage]
	);

	return (
		<PaginationProvider
			totalCount={groupLogos?.length || 0}
			onPageChange={setOffset}
			itemsPerPage={itemsPerPage}
			offset={offset}
		>
			<div
				className="w-100"
				role="main"
				aria-label="Mini grid view of brand logos"
			>
				<Tiles
					type="brand"
					data={visibleLogos}
					layout="grid"
					tileSize={TILE_SIZE_MAP[tileSize]}
					className={`justify-content-center mini-grid-${tileSize}`}
				/>
			</div>
			<div
				className="py-4 d-flex justify-content-center align-items-center"
				role="navigation"
				aria-label="Brand logos navigation"
			>
				<Pagination />
			</div>
		</PaginationProvider>
	);
};

export default MiniGridView;
